// Helper functions for ChatBot component

export const createMessage = (text, sender, idOffset = 0) => ({
  id: Date.now() + idOffset,
  text,
  sender,
  timestamp: new Date()
});

export const generateSessionId = () => 
  `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

export const getErrorMessage = () => 
  "I apologize, but I'm having trouble connecting right now. Please try again or use the contact form below to reach our team directly.";

export const quickQuestions = [
  { id: 'q-receptionist', text: 'Tell me about AI receptionist' },
  { id: 'q-how-works', text: 'How does it work?' },
  { id: 'q-pricing', text: 'Show me pricing' },
  { id: 'q-consultation', text: 'Book consultation' },
];

export const formatTimestamp = (date) => {
  return date.toLocaleTimeString('en-GB', { 
    hour: '2-digit', 
    minute: '2-digit' 
  });
};
